<template lang="pug">
  .lista-solicitud-vacaciones.contenedor-interno
    .title
      span Mis solicitudes de vacaciones
      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition(name="fade")
      div.position-relative(
        v-if="!isEditing"
        key="list-solicitudes"
      )
        transition(
          name='fade',
          tag="div",
          v-if="mostrarConfirmacionEnviar"
          )
          confirmar-accion-overlay(
            @close="mostrarConfirmacionEnviar = false"
            @do="aprobar"
            ref="confirmarAprobar"
          )
            span(slot="title") ¿Desea enviar la solicitud?
            span(slot="primaryAction")
              template(v-if="isSending")
                | Enviando...
              template(v-else)
                | Enviar

            span Luego de enviar la notificación a su jefe, no podrá modificarlo

        transition(
          name='fade',
          tag="div",
          v-if="mostrarConfirmacionRechazar"
          )
          confirmar-accion-overlay(
            @close="mostrarConfirmacionRechazar = false"
            @do="rechazar"
            ref="confirmarRechazar"
          )
            span(slot="title") ¿Desea rechazar la solicitud?
            span(slot="primaryAction")
              template(v-if="isSending")
                | Rechazando...
              template(v-else)
                | Rechazar


        .show-closed-text
          span(
            @click="showClosed = !showClosed"
          )
            template(v-if="showClosed") Mostrando todas las solicitudes
            template(v-else) Mostrando solo las solicitudes abiertas

        .body
          table.table.is-striped.is-bordered
            thead
              th Fecha
              th.hide-break-1 Retorno
              th Estado
              th Acciones
            tbody(
              name="table-row"
              is="transition-group"
            )
              tr.row-table(
                v-for="(o,index) in solicitudes"
                v-if="showClosed || (!showClosed && o.estadoData.abierto)"
                :key="index"
                :class="{'is-close': !o.estadoData.abierto}"
              )
                td
                  .td-wrapper
                    .dates-wrapper.hint--top(:aria-label="'Solicitud: ' + o.id")
                      span {{ o.desde }}
                      span.hide-break-1 &nbsp;-&nbsp;
                      span {{ o.hasta }}
                    div.show-break-1.dates-wrapper
                      span.has-text-bold Retorno:
                      span {{ o.retorno }}
                      span.email ({{ o.dias }} días)
                td.hide-break-1
                  .td-wrapper
                    span {{ o.retorno }}&nbsp;
                    span.email ({{ o.dias }} días)
                td
                  .td-wrapper
                    span {{ o.estadoData.descripcion }}
                td
                  .td-wrapper
                    .contenedor-acciones(v-if="o.estado === 1 && !o.esSolicitudPasada")
                      button.button.is-small(@click="enterEditMode(o)")
                        span.icon.is-small
                          i.fa.fa-pencil-square-o
                        span Editar
                      button.button.is-small(@click="confirmarAprobar(o)")
                        span.icon.is-small
                          i.fa.fa-paper-plane-o
                        span Enviar
                      button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                        span.icon.is-small
                            i.fa.fa-times
                        span Rechazar
                    .contenedor-acciones(v-else-if="o.estado === 2 && !o.esSolicitudPasada")
                      button.button.is-small.is-danger(@click="confirmarRechazo(o)")
                        span.icon.is-small
                          i.fa.fa-times
                        span Rechazar
                    .contenedor-acciones(v-else-if="o.estado > 2")
                      span No hay acciones
                    .contenedor-acciones(v-else)
                      span.has-text-danger Solicitud no aprobada oportunamente, solicitar a RRHH que lo apruebe
          loading(v-if="isLoading")
      div(
        key="edit-solicitud"
        v-else
      )
        nueva-solicitud-vacaciones(
          :is-editing="true"
          :solicitud="solicitudSeleccionada"
          @close="isEditing = false"
          @closeRefresh="isEditing = false; fetch();"
          ref="editarSolicitud"
        )
</template>

<script>
import { apiGet, apiPost, apiDelete, notify } from '../util/general'
import { scrollTo } from '../util/scroll'
import SolicitudVacacionesComponent from './Component_Solicitud_Vacaciones'
import ConfirmarAccionOverlayComponent from './Component_Confirmar_Accion_Overlay'

// import data from '../util/data'
export default {
  name: 'lista_solicitud_vacaciones_component',
  components: {
    'nueva-solicitud-vacaciones': SolicitudVacacionesComponent,
    'confirmar-accion-overlay': ConfirmarAccionOverlayComponent
  },
  data () {
    return {
      solicitudes: [],
      solicitudSeleccionada: {},
      showClosed: false,
      isEditing: false,
      isLoading: true,
      mostrarConfirmacionEnviar: false,
      mostrarConfirmacionRechazar: false,
      isSending: false,
      screenWidth: window.innerWidth
    }
  },
  created () {
    this.fetch()
  },
  mounted () {
    window.addEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  },
  beforeDestroy () {
    window.removeEventListener('resize', () => {
      this.screenWidth = window.innerWidth;
    });
  },
  methods: {
    fetch () {
      var vm = this
      vm.isLoading = true
      var obj = {}
      apiGet(vm, '/vacaciones/empleado/solicitud', obj, function (data) {
        vm.solicitudes = data.lista
        if (vm.solicitudes.length === 0) vm.$emit('close')
      }, function (error) {
        alert('error: ' + error.message)
      },
      function () {
        vm.isLoading = false
      }
      )
    },
    enterEditMode (o) {
      this.solicitudSeleccionada = o
      this.isEditing             = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.editarSolicitud.$el,
          mobile: 0,
          desktop: -60,
          hasPermisoSolicitud: true
        });
      })
    },
    confirmarAprobar (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionEnviar = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.confirmarAprobar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      })
    },
    confirmarRechazo (o) {
      this.solicitudSeleccionada = o
      this.mostrarConfirmacionRechazar = true
      this.$nextTick(() => {
        scrollTo({
          vm:this,
          ref:this.$refs.confirmarRechazar.$el,
          mobile: -30,
          desktop: -60,
          hasOverlay: true
        });
      })
    },
    aprobar () {
      var vm = this
      if (vm.isSending) return
      vm.isSending = true
      var obj = {
        id: vm.solicitudSeleccionada.id
      }

      apiPost(vm, '/vacaciones/solicitud/send', obj, function (data) {
        vm.mostrarConfirmacionEnviar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    },
    rechazar () {
      var vm = this
      if (vm.isSending) return

      vm.isSending = true
      var obj = {
        id: this.solicitudSeleccionada.id,
        isMisSolicitudes: true
      }

      apiDelete(vm, '/vacaciones/empleado/solicitud', obj, function (data) {
        vm.mostrarConfirmacionRechazar = false
        vm.fetch()
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isSending = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .contenedor-interno
    .close
      position absolute
      right 5px
      top 5px
      cursor pointer
      i
        font-size 16px

    .title
      font-size 16px
      padding-right: 10px
      padding-left: 10px
      span
        font-weight bold
        text-transform uppercase

  .contenedor-acciones
    display flex
    justify-content space-around
    .button
      flex 1
      margin 0px 5px
      // i
      //   font-size 15px

  .row-table
    transition all 0.3s ease
    &.is-close
      background-color #ffd6d6 !important

  th
    text-align center

  .table-row-enter, .table-row-leave-active {
    opacity: 0
    height 0
  }

  .show-closed-text
    cursor pointer
    color #12537e
    padding-bottom 10px

  .lista-solicitud-vacaciones
  td
    .email
      font-size 12px
      color #9a9a9a

  .show-break-1
    display none

  // .hide-break-1
  //   display initial


  @media (max-width 694px)
    td
      text-align: center
      vertical-align: middle
      .contenedor-acciones
        flex-direction: column
        .button
          margin-bottom 5px
          &:last-child
            margin-bottom 0px

  @media (max-width 583px)
    .table
      font-size 12px
      td
        text-align: center
        vertical-align: middle
      .td-wrapper
        display flex
        justify-content: center
        align-items: center
        flex-direction: column

        .dates-wrapper
          display: flex
          flex-direction: column


    .show-break-1
      display initial

    .hide-break-1
      display none
</style>



// WEBPACK FOOTER //
// Lista_Solicitud_Vacaciones_Component.vue?7609ee55